import React, { Fragment, useContext, useEffect, useState } from "react";
import classes from "./Menu.module.scss";
import { Container } from "@material-ui/core";
import result_logo from "../../assets/icons/viewResult.svg";
import trivia_maker_logo from "../../assets/icons/triviamaker_logo.svg";
import our_games_logo from "../../assets/MainMenu/OurGames.svg";
import start_game_logo from "../../assets/MainMenu/Play.svg";
import Card from "../../components/gamemenu/menucard";
import "../../Background.scss";
import {
  TRIVIA_GAMES,
  GAME_INTRO,
  RESUME_GAME_RULES,
} from "../routes/RoutesConstants";
import { Header } from "../../components/Trivia/Header/Container";
import {
  WEBSITE_LINK,
  GAME_CODE_EXPIRED_MSG,
  TOKEN_EXPIRED,
  MOVE_TO_QUESTION,
  START_ROUND,
  START_NEXT_ROUND,
  GAME_COMPANY,
  WEBSITE_LINK_HQ,
} from "../../constants";
import NetworkManager from "../../services/NetworkManager";
import { useAuthContext } from "../../context/Auth/AuthContainer";
import { CircularSpinner } from "../../components/Spinner/Spinner";
import { usePopupContext } from "../../context/Popup/PopupContainer";
import TriviaMakerPopup from "../TriviaMakerPopup/TriviaMakerPopup";
import { GameStateContext } from "../../context/GameState/GameStateContext";

///add audio
import { useMusicContext } from "../../context/Music/MusicContainer";
import { EAudioSounds, EGameCompany } from "../Enums/Enums";
import PusherSubscription from "../../components/Trivia/GameLobby/PusherSubscription";
import {
  getChannel,
  isUserRefreshed,
  removeUserRefreshStatus,
} from "../../utilities/util";
import LocalStorage from "../../services/LocalStorage";
// import { useHistory } from "react-router-dom";

const Menu: React.FunctionComponent = () => {
  // const history = useHistory();
  const { logoutUser, setErrorMessage } = useAuthContext();
  const [isLoading, showLoader] = useState<boolean>(true);
  const { popup, showPopup } = usePopupContext();
  const [gamePlaying, setGamePlaying] = useState(false);
  const { setGameState, isAlreadyLoaded, gameCode } = useContext(
    GameStateContext
  );

  ////add audio
  const { changeAudioClip, resetSFXAudio } = useMusicContext();

  useEffect(() => {
    getChannelStatus();
    checkStatus();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const checkStatus = () => {
    const refreshStatus = isUserRefreshed();
    if (refreshStatus) {
      removeUserRefreshStatus();
      window.location.reload();
    } else {
      getGameStatus();
    }
  };

  const getChannelStatus = async () => {
    try {
      const { occupied } = await NetworkManager.GetChannelStatus(
        `${gameCode}-game-running`
      );
      setGamePlaying(occupied);
    } catch (err) {}
  };
  const getGameStatus = async () => {
    try {
      showLoader(true);
      // if (refetchPlayers) refetchPlayers();
      await NetworkManager.GetGameStatus();
      if (setGameState)
        setGameState({
          isAlreadyLoaded: true,
        });
      changeAudioClip(EAudioSounds.BGMusic, true);
      resetSFXAudio();
      showLoader(false);
    } catch (err) {
      // console.log("Error while fetching game status",err);
      try {
        const error = err as any;
        const errorMessage =
          error?.response?.data?.message ??
          "Something Went Wrong! Please Try again!.";
        setError(errorMessage);
      } catch (err) {}

      logoutUser();
    }
  };
  const setError = (errorMessage: string) => {
    if (errorMessage === GAME_CODE_EXPIRED_MSG) {
      setErrorMessage({
        value: errorMessage,
        color: "#FC5C65",
      });
    } else if (errorMessage === TOKEN_EXPIRED) {
      setErrorMessage({
        value: "SESSION EXPIRED, LOG IN AGAIN",
        color: "#FC5C65",
      });
    }
  };
  const openTriviaPopup = () => {
    showPopup(<TriviaMakerPopup />);
  };

  // const onPlayTriviaClicked = async () => {
  //   try {
  //     const path = gamePlaying ? RESUME_GAME_RULES : GAME_INTRO;
  //     // await getGameStatus();
  //     history.push(path);
  //   } catch (err) {}
  // };

  const onPusherEventTrigger = async (eventName: string, data: any) => {
    switch (eventName) {
      case MOVE_TO_QUESTION:
      case START_ROUND:
      case START_NEXT_ROUND:
        setGamePlaying(true);
        break;
    }
  };

  const menuScreen = () => {
    return (
      <div className={classes["menu"]}>
        <PusherSubscription
          channel={getChannel(gameCode)}
          events={[MOVE_TO_QUESTION, START_ROUND]}
          callback={onPusherEventTrigger}
        />
        <header className={classes["menu-header"]}>
          <Header
            fontSize="9em"
            text={["VIRTUAL TRIVIA!"]}
            className={classes["header-padding"]}
            classHeader={classes["header-font"]}
          >
            <Container
              maxWidth="lg"
              style={{
                display: "flex",
                justifyContent: "center",
                transform: "rotate(0.9deg)",
              }}
              className={classes["container"]}
            >
              <div
                className={`row ${classes["menu-card-container"]} mt-4 mb-2`}
              >
                <Card
                  label={"OUR GAMES"}
                  logo_path={our_games_logo}
                  // path={QUIZ_LIST}
                  onClick={() => {
                    window.open(GetWebsiteLink(), "_blank");
                  }}
                  className="mt-4"
                ></Card>

                <Card
                  label={"VIEW RESULTS"}
                  logo_path={result_logo}
                  path={TRIVIA_GAMES}
                  className="mt-3"
                ></Card>
                <Card
                  label={"TRIVIA MAKER"}
                  logo_path={trivia_maker_logo}
                  className="mt-2"
                  path={"/"}
                  onClick={openTriviaPopup}
                ></Card>
                <Card
                  label={gamePlaying ? "RESUME TRIVIA" : "PLAY TRIVIA"}
                  logo_path={start_game_logo}
                  path={gamePlaying ? RESUME_GAME_RULES : GAME_INTRO}
                  // onClick={onPlayTriviaClicked}
                ></Card>
              </div>
            </Container>
          </Header>
          {FooterText()}
        </header>
      </div>
    );
  };

  return (
    <Fragment>
      {popup ? popup : null}
      {isLoading ? (
        <CircularSpinner
          backdropAlpha={isAlreadyLoaded ? true : false}
        ></CircularSpinner>
      ) : null}
      {menuScreen()}
    </Fragment>
  );
};

export default Menu;

export const FooterText = () => {
  return <div className={classes["footer"]}>Release v1.0.0</div>;
};

export const GetWebsiteLink = (): string => {
  const company = LocalStorage.GetItem(GAME_COMPANY) || "";
  switch (company) {
    case EGameCompany.Experios:
      return WEBSITE_LINK;
    case EGameCompany.EscapeHQ:
      return WEBSITE_LINK_HQ;
    default:
      return WEBSITE_LINK;
  }
};
